import { useState } from "react";
import Navbar from "../components/Navbar";
import FounderNote from "../components/FounderNote";
import Faq from "../components/Faq";
import FinalCTA from "../components/FinalCTA";
import Footer from "../components/Footer";

export default function ContactPage() {
    const [isSending, setIsSending] = useState(false);
    const [status, setStatus] = useState({ type: "", text: "" });

    const handleSubmit = async (event) => {
        event.preventDefault();
        const form = event.currentTarget;
        const formData = new FormData(form);

        setIsSending(true);
        setStatus({ type: "", text: "" });

        try {
            const response = await fetch(
                "https://formsubmit.co/ajax/rootpointersfrontend@gmail.com",
                {
                    method: "POST",
                    headers: {
                        Accept: "application/json",
                    },
                    body: formData,
                }
            );

            if (!response.ok) {
                throw new Error("Failed to send message");
            }

            setStatus({
                type: "success",
                text: "Message sent successfully. Team will contact you soon.",
            });
            form.reset();
        } catch (error) {
            setStatus({
                type: "error",
                text: "Unable to send message. Please try again.",
            });
        } finally {
            setIsSending(false);
        }
    };

    return (
        <div className="bg-background text-foreground min-h-screen">
            <Navbar />
            <main data-testid="contact-page" className="pt-[7rem]">
                <section id="contact" className="py-16 md:py-20 bg-muted/30 border-b">
                    <div id="download" className="scroll-mt-28 max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
                        <div className="grid lg:grid-cols-2 gap-8 lg:gap-12 items-start">
                            <div>
                                <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-primary/10 text-primary text-sm font-semibold mb-5">
                                    Contact Us
                                </div>
                                <h1 className="text-3xl md:text-4xl font-bold tracking-tight text-foreground">
                                    Reach out to the Genesis team
                                </h1>
                                <p className="mt-4 text-lg text-muted-foreground leading-relaxed max-w-xl">
                                If you need support, want to provide app feedback, discuss a partnership, or require any other assistance, please fill out the form. Our team will get back to you as soon as possible.
                                </p>
                            </div>

                            <form
                                data-testid="contact-form"
                                onSubmit={handleSubmit}
                                className="bg-card border rounded-2xl p-6 md:p-7 space-y-4 shadow-sm"
                            >
                                <input type="hidden" name="_subject" value="New Contact Form Submission" />
                                <input type="hidden" name="_captcha" value="false" />
                                <div className="grid sm:grid-cols-2 gap-4">
                                    <div>
                                        <label
                                            htmlFor="fullName"
                                            className="block text-sm font-medium text-foreground mb-1.5"
                                        >
                                            Full Name
                                        </label>
                                        <input
                                            id="fullName"
                                            name="fullName"
                                            type="text"
                                            required
                                            className="w-full h-11 rounded-lg border border-slate-200 bg-white px-3 text-sm text-slate-900 placeholder:text-slate-400 focus:outline-none focus:ring-2 focus:ring-primary/40"
                                            placeholder="Enter your name"
                                        />
                                    </div>
                                    <div>
                                        <label
                                            htmlFor="email"
                                            className="block text-sm font-medium text-foreground mb-1.5"
                                        >
                                            Email
                                        </label>
                                        <input
                                            id="email"
                                            name="email"
                                            type="email"
                                            required
                                            className="w-full h-11 rounded-lg border border-slate-200 bg-white px-3 text-sm text-slate-900 placeholder:text-slate-400 focus:outline-none focus:ring-2 focus:ring-primary/40"
                                            placeholder="name@email.com"
                                        />
                                    </div>
                                </div>
                                <div>
                                    <label
                                        htmlFor="subject"
                                        className="block text-sm font-medium text-foreground mb-1.5"
                                    >
                                        Subject
                                    </label>
                                    <input
                                        id="subject"
                                        name="subject"
                                        type="text"
                                        required
                                        className="w-full h-11 rounded-lg border border-slate-200 bg-white px-3 text-sm text-slate-900 placeholder:text-slate-400 focus:outline-none focus:ring-2 focus:ring-primary/40"
                                        placeholder="How can we help?"
                                    />
                                </div>
                                <div>
                                    <label
                                        htmlFor="message"
                                        className="block text-sm font-medium text-foreground mb-1.5"
                                    >
                                        Message
                                    </label>
                                    <textarea
                                        id="message"
                                        name="message"
                                        required
                                        rows={5}
                                        className="w-full rounded-lg border border-slate-200 bg-white px-3 py-2.5 text-sm text-slate-900 placeholder:text-slate-400 focus:outline-none focus:ring-2 focus:ring-primary/40"
                                        placeholder="Write your message..."
                                    />
                                </div>
                                <button
                                    type="submit"
                                    disabled={isSending}
                                    className="inline-flex items-center justify-center h-11 px-6 rounded-full bg-slate-950 text-white text-sm font-semibold hover:bg-slate-800 transition-colors"
                                >
                                    {isSending ? "Sending..." : "Send Message"}
                                </button>
                                {status.text && (
                                    <p
                                        className={`text-sm ${
                                            status.type === "success"
                                                ? "text-emerald-600"
                                                : "text-rose-600"
                                        }`}
                                    >
                                        {status.text}
                                    </p>
                                )}
                            </form>
                        </div>
                    </div>
                </section>
                <FounderNote />
                <Faq />
                <FinalCTA />
            </main>
            <Footer />
        </div>
    );
}
